import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { usePlatformContext } from '@/features/platform/use-context';

/**
 * Gatea una ruta por modulo activo. Si el tenant no lo tiene activo, redirige
 * al inicio. Mientras carga el contexto no renderiza nada (evita flicker).
 */
export function RequireModule({
  moduleKey,
  children,
}: {
  moduleKey: string;
  children: ReactNode;
}): JSX.Element | null {
  const { data, isLoading } = usePlatformContext();
  if (isLoading) return null;
  if (!data?.modules.includes(moduleKey)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
